// Define application wide routes
const ROUTE_PATH = {
  LOGIN: '/login',
  DASHBOARD: '/',
  REALTIME_DASHBOARD: '/realtime-dashboard',
  CONTENT_CHANNELS: '/engagement/apps',
  CONTENT_VIDEOS: '/engagement/videos',
  CONTENT_PLAYLISTS: '/engagement/playlists',
  SUBSCRIBERS: '/users/all',
  ADMIN_USERS: '/settings/access',
  SMTP_SETTINGS: '/settings/email',
  COUPONS_CONFIG: '/settings/coupon-codes',
  BILLING_SUBSCRIPTIONS: '/users/subscribers',
  REPORTS_OVERVIEW: '/reports/overview',
  REPORTS_LIVE_USERS: '/reports/live-users',
  REPORTS_SESSIONS: '/engagement/video-sessions',
  REPORTS_APP_SESSIONS: '/engagement/app-sessions',
  REPORTS_MIGRATION_STATUS: '/reports/migration',
  REPORTS_MIGRATION_USERS: '/reports/migration-users',
  REPORTS_ACTIVE_SUBSCRIBERS: '/reports/active-subscribers',
  REPORTS_TRIAL_SUBSCRIBERS: '/reports/trial-subscribers',
  REPORTS_CHANNEL_ALL_USERS: '/reports/users-count-overview',
  CONTENT_ALL_CHANNELS: '/content/channels',
  CONTENT_CHANNEL_EDIT: '/content/channels/:id/edit',
  CHANNEL_DEFAULT_CONTENT: '/content/channel/default-content',
  MANAGE_SCHEDULE: '/content/manual-assign-schedule',
  MANAGE_CONTENT_OWNER_SCHEDULE: '/content-owner/channel/schedule',
  CHANNEL_PREVIEW: '/content/channel-preview',
  VIDEOS: '/content/videos',
  VIDEO_EDIT: '/content/videos/:id/edit',
  ADVERTISERS_TAG_LIBRARY: '/advertisers/tags',
  ADVERTISERS_TAG_ASSIGN: '/advertisers/tag-assign',
  ADVERTISERS_TAG_DEPLOYED: '/advertisers/deployed-tags',
  OZYPLAY_SETTINGS: '/advertisers/ozyplay-settings',
  CONTENT_GENRES: '/content/genres',
  CONTENT_COLLECTIONS: '/content/collections',
  CONTENT_ALL_PLAYLISTS: '/content/playlists',
  MANAGE_RULES: '/content/manage-rules',
  SERIES: '/content/series',
  CONTENT_CHANNEL_GENRES: '/content/channel/genres',
  CONTENT_MANAGE_DESCRIPTIONS: '/content/manage-descriptions',
  LICENSE_MANAGEMENT: '/content/license-management',
  CONTENT_OWNERS: '/distributor',
  CONTENT_OWNERS_CREATE: '/distributor/create',
  CONTENT_OWNERS_EDIT: '/distributor/:id/edit',
  CONTENT_OWNERS_VIEW_DETAILS: '/distributor/:id/view',
  AUTOLOGIN: '/auto-login',
  IMPORT: '/data-management',
  WORKSPACE_SETTINGS: '/settings/workspace',
  VIDEO_VIEW_DETAILS: '/content/videos/:id/view',
  CHANNEL_VIEW_DETAILS: '/content/channels/:id/view',
  USER_PROFILE: '/profile',
  VIDEO_PREVIEW: '/content/videos/:id/popup-view',
  CONTENT_SCHEDULING: '/content/rulebased-assign-schedule',
  FAILED_SUBSCRIPTIONS: '/reports/failed-subscriptions',
  CANCEL_SUBSCRIPTION_REQUESTS: '/reports/cancel-subscription-requests',
  EMAIL_TEMPLATES: '/settings/email-templates',
  COUPONS_CATEGORIES_SETTINGS: '/settings/coupon-code/categories',
  BLACKLIST_SOURCES_SETTINGS: '/settings/blacklist-sources',
  SYSTEM_HEALTH_SETTINGS: '/settings/system-health',
  HLS_TRANSCODER_LEGACY: '/content/hls-transcoder/legacy',
  HLS_TRANSCODER_OBJECT: '/content/hls-transcoder/object',
  CONTENT_SOURCES: '/content/sources',
  LOGOUT: '/logout',
  REPORTS_PROMO_CODE: '/reports/subscribers-promocode',
  CHANNEL_PACKAGER: '/content/channel-packager',
  CONTENT_ALL_PLAYLISTS_CREATE: '/content/playlists/create',
  CONTENT_ALL_PLAYLISTS_EDIT: '/content/playlists/:id/edit',
  WEBSUBSCRIBER_ANALYTICS: '/reports/web-subscriber-analytics',
};

export default ROUTE_PATH;
